// extracted by mini-css-extract-plugin
export default {"container":"StoreNotFound_container__of4ko","content":"StoreNotFound_content__ZTa2G"};